import { render, staticRenderFns } from "./CollectSchemeTextDetail.vue?vue&type=template&id=046f6b22&scoped=true&"
import script from "./CollectSchemeTextDetail.vue?vue&type=script&lang=js&"
export * from "./CollectSchemeTextDetail.vue?vue&type=script&lang=js&"
import style0 from "./CollectSchemeTextDetail.vue?vue&type=style&index=0&id=046f6b22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046f6b22",
  null
  
)

export default component.exports